module.exports = __webpack_public_path__ + "static/media/umbrella-loader-sky-blue.9fade4c4.gif";